import { render } from "./DashboardCreateTop.vue?vue&type=template&id=b456e0a0&scoped=true"
import script from "./DashboardCreateTop.vue?vue&type=script&lang=js"
export * from "./DashboardCreateTop.vue?vue&type=script&lang=js"

import "./DashboardCreateTop.vue?vue&type=style&index=0&id=b456e0a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b456e0a0"]])

export default __exports__